export default __webpack_public_path__ + "static/media/loading.24b933aa.gif";